import React, { useEffect, useState, useMemo, useCallback } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Checkbox, FormControlLabel, FormGroup, Grid, TextField } from '@mui/material';
import CheckboxItem from './CheckboxItem2';
import debounce from 'lodash.debounce';



const EcecCustomerFilterAccordion = React.memo((props) => {
	let { onChangeCategory, selectedList = [], qualificationList = [], levels, 
		showTwoColumns = true, includeTeacherCategory = false, isChildcareCentre = false } = props
	const [showDetail, setShowDetail] = useState({})
	const [searching, setSearching] = useState({})

	// let countItem = {}
	const mapSelectedList = (selectedList) => {
		return selectedList?.map(item => {
			return item?.split("_id:")?.[0]
		}) || []
	}

	const newSelectedList = useMemo(() => {
		return mapSelectedList(selectedList)
	}, [selectedList])

	const countChecked = (selectedList, currentCategories) => {
		const countResult = {};
		for (const category of currentCategories) {
			const qualifications = category.qualifications;
			for (const item of qualifications) {
				if (newSelectedList.includes(item._id)) {
					if (category.type === 'vet') {
						countResult[category._id] = (countResult[category._id] || 0) + 1;
						countResult[category.type] = (countResult[category.type] || 0) + 1;
						countResult[item._id] = (countResult[item._id] || 0) + 1;
						countResult[`vet_${category._id}_level_${item.level}`] = (countResult[`vet_${category._id}_level_${item.level}`] || 0) + 1;
					}
					else {
						countResult[category._id] = (countResult[category._id] || 0) + 1;
						countResult[category.type] = (countResult[category.type] || 0) + 1;
					}
					
				}
				else {
					if (category.type === 'vet') {
						const { units } = item
						for (const unit of units) {
							if (selectedList.includes(unit._id)) {
								countResult[category._id] = (countResult[category._id] || 0) + 1;
								countResult[category.type] = (countResult[category.type] || 0) + 1;
								countResult[item._id] = (countResult[item._id] || 0) + 1;
								countResult[`vet_${category._id}_level_${item.level}`] = (countResult[`vet_${category._id}_level_${item.level}`] || 0) + 1;
							}
						}
					}
				}
			}
		}
		return countResult
	};

	const countItem = useMemo(() => {
		return countChecked(selectedList, qualificationList)
	}, [selectedList, qualificationList]);

	const memoizedOnChangeCategory = useCallback((event, qua = null, rootID) => {
		onChangeCategory(event, qua, rootID);
	}, [onChangeCategory]);

	

	const onShowing = (key, expanded = false) => {
		setShowDetail({
			...showDetail,
			[key]: expanded
		})
	}

	const debouncedOnChange = debounce((value, id) => {
        setSearching({
        ...searching,
        [id]: value
        });
    }, 300);

	const handleInputChange = (e, qua) => {
        const { value } = e.target;
        debouncedOnChange(value, qua._id);
    };

	return (
		<div>
			{
				isChildcareCentre ? (
					<Accordion onChange={(event, expanded) => onShowing('ecec', expanded)}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel3a-content"
							id="panel3a-header"
						>
							<Typography sx={{ width: '70%', flexShrink: 0 }}>Early Childhood Education & Care (ECEC)</Typography>
							<Typography sx={{ color: 'primary.main' }}>{countItem['ecec'] ? `${countItem['ecec']} item(s) selected` : ''}</Typography>
						</AccordionSummary>
						{ showDetail['ecec'] && <AccordionDetails>
							{qualificationList.filter(item => item.type === 'ecec').map((item, index) => {
								return (
									<Accordion onChange={(event, expanded) => onShowing(`ecec_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel1a1-content"
											id="panel1a1-header"
										>
											<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name}</Typography>
											<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
										</AccordionSummary>
										{showDetail[`ecec_${item._id}`] && <AccordionDetails>
											<FormGroup>
												<Grid container spacing={2}>
													{item.qualifications
														// .filter((item) => item.type.includes('ge') && !item.whole_name.includes('All Levels'))
														.map((ele, indexEle) => {
															const shouldChecked = selectedList.includes(ele._id) ? true : false;

															return (
																<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																	<CheckboxItem ele={ele} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e)}/>
																</Grid>
															);
														})}
												</Grid>
											</FormGroup>
										</AccordionDetails>}
									</Accordion>
								)
							})}
						</AccordionDetails>
						}
					</Accordion>
				) : null
			}
		</div>

	);
})

export default EcecCustomerFilterAccordion
